import React from "react";
import styled from "styled-components";

const Rank = styled.span<{ $top: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  background: ${(p) => (p.$top ? "var(--brand)" : "#F1F3F4")};
  color: ${(p) => (p.$top ? "#ffffff" : "var(--text)")};
`;

/** Posição no ranking dos casos: os três primeiros em azul (prancheta Cases). */
export const RankBadge: React.FC<{ rank: number }> = ({ rank }) => (
  <Rank $top={rank <= 3} aria-label={`Posição ${rank}`}>{rank}</Rank>
);

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .track {
    width: 90px;
    height: 6px;
    border-radius: 999px;
    background: #f1f3f4;
    overflow: hidden;
  }
  .track > span {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: #1e8e3e;
  }
  .pct {
    font-family: var(--font-sans);
    font-weight: 500;
    white-space: nowrap;
  }
`;

/** Taxa de sucesso (ranqueadas / total) com barra. Aceita 0–1 ou 0–100. */
export const RateBar: React.FC<{ rate: number }> = ({ rate }) => {
  const pct = Math.max(0, Math.min(100, rate <= 1 ? rate * 100 : rate));
  return (
    <Bar>
      <span className="track" aria-hidden="true">
        <span style={{ width: `${pct}%` }} />
      </span>
      <span className="pct">{Math.round(pct)}%</span>
    </Bar>
  );
};
